/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Export_Preset_Save_TitleInputs */



/**
* | output |
* | --- |
* | "Save Video Export Preset" |
*
* @param {Video_Export_Export_Preset_Save_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_export_preset_save_title = /** @type {((inputs?: Video_Export_Export_Preset_Save_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Export_Preset_Save_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer le prereglage d'exportation video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Video-Exportvoreinstellung speichern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva preimpostazione esportazione video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранить настройки экспорта видео")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar ajuste preestablecido de exportación de vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存视频导出预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオエクスポートプリセットを保存")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो निर्यात प्रीसेट सहेजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvar predefinição de exportação de vídeo")
	return /** @type {LocalizedString} */ ("Save Video Export Preset")
});